import { Button, colors } from '@giphy/react-giphy-brand'
import { Fragment } from 'react'
import styled, { css } from 'styled-components'

const getColor = index => {
    if (index === 0) {
        return colors.giphyDarkCharcoal
    }
    if (index % 2 === 0) {
        return colors.giphyDarkestGrey
    }
    if (index % 1 === 0) {
        return colors.giphyDarkGrey
    }
    return colors.giphyDarkCharcoal
}

const SelectableButton = styled(Button)(
    ({ index, selected }) => css`
        background: ${selected ? colors.giphyGreen : getColor(index)};
        color: ${selected ? colors.giphyBlack : colors.giphyWhite};
        &:hover {
            background: ${colors.giphyGreen};
            color: ${colors.giphyBlack};
        }
    `,
)

const InputButton = ({ index, selected, val, label, onClick }) => (
    <Fragment>
        <SelectableButton type="button" {...{ index, selected, onClick }}>
            {label || val}
        </SelectableButton>
        {selected && <input name="gender" hidden value={val} readOnly />}
    </Fragment>
)

export default InputButton
